import { IconNote, IconProjects } from '../../../common/icons';
import Picker from '../../../common/components/picker/picker';
// Cross-feature import, on purpose: which clients exist is the clients
// feature's knowledge, and a second copy of that path here is a second place
// to fix the day it changes.
import { searchClients } from '../../clients/contexts/clients';
import {
    NAME_MAX,
    PROJECT_STATE_OPTIONS,
    SLUG_MAX,
    STATUS_OPTIONS,
} from '../utils/form';

import '../../clients/styles/form.css';

export default function ProjectFields({
    values, errors = {}, onChange, disabled, visible, clientLabel,
}) {
    const set = (field) => (e) => onChange(field, e.target.value);
    // `visible` undefined means show everything, which is what the edit form
    // does: editing is one page, never a walk through steps.
    const show = (field) => !visible || visible.includes(field);
    const state = PROJECT_STATE_OPTIONS.find(option => option.value === values.project_state);

    return (
        <div className="client-form__grid">
            {show('client_id') && (
                <label className="client-form__field">
                    <span className="client-form__label">
                        Cliente <span className="client-form__required">*</span>
                    </span>
                    <span className="client-form__control">
                        <Picker
                            value={values.client_id}
                            onChange={(id) => onChange('client_id', id)}
                            fetchOptions={searchClients}
                            cacheKey="clients"
                            labelOf={client => client.name}
                            subtitleOf={client => client.contact || ''}
                            selectedLabel={clientLabel}
                            placeholder="Elegir cliente..."
                            disabled={disabled}
                            invalid={!!errors.client_id}
                        />
                    </span>
                    {errors.client_id && <span className="client-form__error">{errors.client_id}</span>}
                </label>
            )}

            {show('project_state') && (
                <label className="client-form__field">
                    <span className="client-form__label">Estado del proyecto</span>
                    <span className="client-form__control">
                        <select
                            className="client-form__input client-form__input--select"
                            value={values.project_state}
                            onChange={set('project_state')}
                            disabled={disabled}
                        >
                            {PROJECT_STATE_OPTIONS.map(option => (
                                <option key={option.value} value={option.value}>{option.label}</option>
                            ))}
                        </select>
                    </span>
                    {errors.project_state
                        ? <span className="client-form__error">{errors.project_state}</span>
                        : state && <span className="client-form__note">{state.hint}</span>}
                </label>
            )}

            {show('name') && (
                <label className="client-form__field">
                    <span className="client-form__label">
                        Nombre <span className="client-form__required">*</span>
                    </span>
                    <span className="client-form__control">
                        <input
                            className={`client-form__input ${errors.name ? 'client-form__input--invalid' : ''}`}
                            type="text"
                            value={values.name}
                            onChange={set('name')}
                            maxLength={NAME_MAX}
                            placeholder="Nombre del proyecto"
                            disabled={disabled}
                            required
                        />
                        <span className="client-form__icon" aria-hidden="true"><IconProjects /></span>
                    </span>
                    {errors.name && <span className="client-form__error">{errors.name}</span>}
                </label>
            )}

            {show('slug') && (
                <label className="client-form__field">
                    <span className="client-form__label">
                        Slug <span className="client-form__required">*</span>
                    </span>
                    <span className="client-form__control">
                        <input
                            className={`client-form__input client-form__input--mono ${errors.slug ? 'client-form__input--invalid' : ''}`}
                            type="text"
                            value={values.slug}
                            onChange={set('slug')}
                            maxLength={SLUG_MAX}
                            placeholder="nombre-del-proyecto"
                            disabled={disabled}
                            required
                        />
                    </span>
                    {errors.slug
                        ? <span className="client-form__error">{errors.slug}</span>
                        : (
                            <span className="client-form__note">
                                Único y para siempre visible en URLs. Se arma solo desde el
                                nombre hasta que lo edites a mano.
                            </span>
                        )}
                </label>
            )}

            {show('description') && (
                <label className="client-form__field client-form__field--wide">
                    <span className="client-form__label">Descripción</span>
                    <span className="client-form__control">
                        <textarea
                            className={`client-form__input client-form__input--area ${errors.description ? 'client-form__input--invalid' : ''}`}
                            value={values.description}
                            onChange={set('description')}
                            rows={4}
                            placeholder="De qué se trata el proyecto"
                            disabled={disabled}
                        />
                        <span className="client-form__icon client-form__icon--top" aria-hidden="true">
                            <IconNote />
                        </span>
                    </span>
                    {errors.description && <span className="client-form__error">{errors.description}</span>}
                </label>
            )}

            {show('status') && (
                <label className="client-form__field">
                    <span className="client-form__label">Estado del registro</span>
                    <span className="client-form__control">
                        <select
                            className="client-form__input client-form__input--select"
                            value={values.status}
                            onChange={set('status')}
                            disabled={disabled}
                        >
                            {STATUS_OPTIONS.map(option => (
                                <option key={option.value} value={option.value}>{option.label}</option>
                            ))}
                        </select>
                    </span>
                    {errors.status
                        ? <span className="client-form__error">{errors.status}</span>
                        : (
                            <span className="client-form__note">
                                Si la fila se ve o no. Distinto del estado del proyecto.
                            </span>
                        )}
                </label>
            )}
        </div>
    );
}
